import client from './apiConnector';
import { EventBus } from '@/eventBus.js';
import { TEST_SHEET_AGGREGATES } from '../../tests/mocks/sheets.js';

export default {
  async getAggregatesByEstablishmentId(establishmentId) {
    try {
      const response = await client().post(`/playlist/groups/${establishmentId}/sheets`, {});
      const sheetAggregates = response.data
        .map(sheet => {
          if (!sheet.reference) {
            sheet.reference = { source: 'Hawwwai', value: sheet.id };
          }
          return sheet;
        })
        .reduce((aggregates, sheet) => {
          const aggregate = aggregates.find(it => it.reference.value === sheet.reference.value) || null;
          if (aggregate) {
            aggregate.sheets.push(sheet);
          } else {
            const { gps } = sheet.location;
            aggregates.push({ reference: sheet.reference, lat: gps.lat, lng: gps.lon, sheets: [sheet] });
          }
          return aggregates;
        }, []);
      return sheetAggregates;
    } catch (e) {
      throw e;
      EventBus.$emit('apiError', { service: 'sheets', method: 'getAggregatesByEstablishmentId', status: 500});
      return [];
    }
  }
}